export default __webpack_public_path__ + "d809e70c54858b198b166540b312ee57.png";